/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  DxpSignupStatusCode,
  DXP_SIGNUP_STATUS_CODE_DONE,
  DXP_SIGNUP_STATUS_CODE_EXPIRED,
  DXP_SIGNUP_STATUS_CODE_PENDING,
} from './DxpSignupStatus.entity.constant';

/**
 * All of the possible `DXP_SIGNUP_STATUS_CODE_*`'s.
 * @export
 */
export const DXP_SIGNUP_STATUS_CODES: ReadonlyArray<DxpSignupStatusCode> = [
  DXP_SIGNUP_STATUS_CODE_DONE,
  DXP_SIGNUP_STATUS_CODE_EXPIRED,
  DXP_SIGNUP_STATUS_CODE_PENDING,
];
